"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateStayDays;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function validateStayDays(minDays, to, from) {
  var days = (0, _moment["default"])(to).diff((0, _moment["default"])(from), 'days');
  return days > minDays;
}